import { render, staticRenderFns } from "./DomesticAirFareCap.vue?vue&type=template&id=552c2622&"
import script from "./DomesticAirFareCap.vue?vue&type=script&lang=js&"
export * from "./DomesticAirFareCap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports